export const APP_STATE_RESET_TO_SYSTEM_DEFAULT = '[App State] Reset to System Default';
export const APP_STATE_RESET_TO_USER_DEFAULT = '[App State] Reset to User Default';
export const APP_STATE_SET_DESERIALIZED_APP_STATE = '[App State] Set Deserialized App State';
